import { Icon } from "@mdi/react";
import { Button } from "@acdc2/ui/components/button";

type Props = {
  path: React.ComponentProps<typeof Icon>["path"];
  disabled?: boolean;
  onClick?: () => void;
};

export function NavbarButtonIcon({
  path,
  disabled,
  onClick,
  ...otherProps
}: Props) {
  return (
    <Button
      {...otherProps}
      variant="ghost"
      size="icon"
      disabled={disabled}
      onClick={onClick}
    >
      <Icon path={path} size="1.25rem" />
    </Button>
  );
}
